import { useEffect, useRef, useState } from 'react';
import type { MissionTemplateReadPort } from '../../mission-workspace/template/consumer/contract';
import type { TemplateProjection } from '../../mission-workspace/template/domain/projection';
import { projectMissionTemplate } from '../../mission-workspace/template/domain/projection';
import { MissionTemplateView } from '../../mission-workspace/template/ui/MissionTemplateView';
import {
  associatedMissionTemplatePin,
  associatedMissionTemplatePort,
  AssociationSequence,
  readAssociatedMissionTemplate,
} from '../consumer/associated-mission-template';
import { SourceFields } from './ScenarioEntryInspector';
export function ScenarioMissionTemplate({
  developmentLoopbackOrigin,
}: {
  readonly developmentLoopbackOrigin?: string;
}) {
  const [state, setState] = useState<TemplateProjection | null>(null);
  const sequence = useRef(new AssociationSequence());
  let port: MissionTemplateReadPort | null = null;
  let configurationError = '';
  try {
    port = associatedMissionTemplatePort(developmentLoopbackOrigin, import.meta.env.DEV);
  } catch {
    configurationError = 'ERROR — explicit loopback development origin required';
  }
  useEffect(() => {
    const current = sequence.current;
    return () => current.invalidate();
  }, []);
  async function read() {
    if (!port) return;
    const ticket = sequence.current.begin();
    setState(projectMissionTemplate({ status: 'LOADING' }));
    const result = await readAssociatedMissionTemplate(port);
    if (sequence.current.current(ticket)) setState(result);
  }
  return (
    <section className="scc-mt">
      <h2>关联任务模板 · 文档关联</h2>
      <p>
        MissionTemplate ≠ Mission。查看不建立 Scenario→Mission Binding。authorizationPoint true /
        false 均不授予批准或执行权限。
      </p>
      <details>
        <summary>关联 MT 的完整六字段 pin</summary>
        <SourceFields value={{ ...associatedMissionTemplatePin }} />
      </details>
      <p>
        既有 MT 只读入口：<a href="/">首页 MissionTemplate exact-pin read</a>
        。来源已形成成员，VERSION CANDIDATE；本页当前读取结果见下方。
      </p>
      {configurationError ? (
        <p role="status">{configurationError}</p>
      ) : port ? (
        <>
          <p>显式隔离开发模式 · 本地 loopback · 尚未请求</p>
          <button
            onClick={() => {
              void read();
            }}
          >
            {state && state.status !== 'LOADING' ? '重试关联任务模板读取' : '读取关联任务模板'}
          </button>
        </>
      ) : (
        <p data-mt-mode>HOLD — 未启用显式本地开发读取。不会自动联系合成 Backend。</p>
      )}
      {state && (
        <>
          {state.body && (
            <p data-mt-counts>
              {state.stages.length} 个有序模板阶段 · authorizationPoint true{' '}
              {state.stages.filter((s) => s.authorizationPoint).length} / false{' '}
              {state.stages.filter((s) => !s.authorizationPoint).length}（声明，不是批准）
            </p>
          )}
          <MissionTemplateView state={state} />
        </>
      )}
    </section>
  );
}
